export default "__VITE_ASSET__ChSBV76E__"